// Bar chart
export const barChartDemo = new Map([
  ['IT', 3_000_000],
  ['Sales', 3_500_000],
  ['Human resources', 4_000_000],
  ['Marketing', 3_000_000],
  ['Finance', 5_000_000],
  ['Legal', 4_100_000]
])

// Line chart
export const lineChartDemoInfo = [
  ['Shopping', 8_550],
  ['Fuel', 2_300],
  ['Subscription', 350]
]

export const lineChartDemoY = [
  [1767387600000, 1_300],
  [1767474000000, 12_000],
  [1767560400000, 600],
  [1767646800000, 100_000.25],
  [1767819600000, 4_500],
  [1767906000000, 16_100],
  [1767992400000, 3_000],
  [1768165200000, 7_540],
  [1768251600000, 44_100],
  [1768424400000, 8_420],
  [1768510800000, 3_600],
  [1768597200000, 11_200],
  [1768770000000, 4_250],
  [1768856400000, 29_200],
  [1768942800000, 10_900],
  [1769029200000, 4_600],
  [1769115600000, 5_850],
  [1769202000000, 20_330],
  [1769288400000, 6_550],
  [1769374800000, 11_720],
  [1769461200000, 2_990],
  [1769547600000, 4_000],
  [1769634000000, 4_100],
  [1769720400000, 2_600]
]

export const lineChartDemoX = [
  1767387600000, 1767387600000, 1767474000000, 1767474000000, 1767474000000, 1767474000000,
  1767474000000, 1767560400000, 1767560400000, 1767646800000, 1767646800000, 1767819600000,
  1767819600000, 1767819600000, 1767906000000, 1767906000000, 1767906000000, 1767906000000,
  1767992400000, 1767992400000, 1768165200000, 1768165200000, 1768165200000, 1768165200000,
  1768165200000, 1768165200000, 1768165200000, 1768251600000, 1768251600000, 1768424400000,
  1768424400000, 1768424400000, 1768424400000, 1768424400000, 1768424400000, 1768424400000,
  1768424400000, 1768510800000, 1768510800000, 1768510800000, 1768510800000, 1768597200000,
  1768597200000, 1768597200000, 1768770000000, 1768770000000, 1768770000000, 1768770000000,
  1768770000000, 1768856400000, 1768856400000, 1768856400000, 1768856400000, 1768856400000,
  1768942800000, 1768942800000, 1768942800000, 1769029200000, 1769029200000, 1769029200000,
  1769115600000, 1769115600000, 1769115600000, 1769115600000, 1769202000000, 1769202000000,
  1769288400000, 1769288400000, 1769374800000, 1769374800000, 1769374800000, 1769374800000,
  1769374800000, 1769374800000, 1769374800000, 1769374800000, 1769374800000, 1769374800000,
  1769461200000, 1769547600000, 1769547600000, 1769547600000, 1769547600000, 1769634000000,
  1769634000000, 1769634000000, 1769634000000, 1769720400000, 1769720400000
]
